exports.components = {
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-templates-pages-property-detail-jsx": () => import("./../../../src/templates/pages/propertyDetail.jsx" /* webpackChunkName: "component---src-templates-pages-property-detail-jsx" */),
  "component---src-templates-pages-property-list-jsx": () => import("./../../../src/templates/pages/propertyList.jsx" /* webpackChunkName: "component---src-templates-pages-property-list-jsx" */)
}

